/**
 * sites domain client — Sites/Locations as customer-managed physical places.
 *
 * Reads need `location:read`; writes need `location:manage` — deliberately the
 * same two keys that already govern work geofences, because a Site's geofence IS
 * a work geofence. Types mirror the API's site service views.
 */
import { del, get, patch, post, put } from './transport.js';
/** `GET /sites` — server-side search across name, code, city and street. */
export async function list(query = {}, options) {
    return get('/sites', { ...options, query: { ...query } });
}
/** `GET /sites/:id`. */
export async function detail(id, options) {
    const body = await get(`/sites/${id}`, options);
    return body.site;
}
/** `GET /sites/map` — active, positioned sites only. Carries no client data. */
export async function map(options) {
    const body = await get('/sites/map', options);
    return body.sites;
}
/** `POST /sites` (needs `location:manage`). */
export async function create(input, options) {
    const body = await post('/sites', input, options);
    return body.site;
}
/** `PATCH /sites/:id` (needs `location:manage`). */
export async function update(id, input, options) {
    const body = await patch(`/sites/${id}`, input, options);
    return body.site;
}
/**
 * `PUT /sites/:id/geofence` — writes the work_geofence row the punch evaluator
 * reads, so this control has a real operational effect. Enabling without site
 * coordinates is refused (409) rather than silently doing nothing.
 */
export async function setGeofence(id, input, options) {
    const body = await put(`/sites/${id}/geofence`, input, options);
    return body.site;
}
/** `GET /sites/:id/programs`. */
export async function programs(id, options) {
    const body = await get(`/sites/${id}/programs`, options);
    return body.programs;
}
/** `PUT /sites/:id/programs` — the same rows `programs.setSites` writes. */
export async function setPrograms(id, input, options) {
    const body = await put(`/sites/${id}/programs`, input, options);
    return body.programs;
}
/**
 * `POST /sites/:id/retire` — stops future use and deactivates the geofence.
 * Historical clock events, punch evaluations and schedules are untouched.
 */
export async function retire(id, reason, options) {
    const body = await post(`/sites/${id}/retire`, { reason }, options);
    return body.site;
}
/** `POST /sites/:id/reactivate` — the geofence is deliberately left off. */
export async function reactivate(id, options) {
    const body = await post(`/sites/${id}/reactivate`, {}, options);
    return body.site;
}
/** `DELETE /sites/:id` — 409 unless nothing at all references the site. */
export async function remove(id, options) {
    await del(`/sites/${id}`, options);
}
//# sourceMappingURL=sites.js.map